
import { GlassWater, ClipboardList, BadgeCheck } from "lucide-react";
import { DashboardFeature } from "./types";

export const bartenderFeatures: DashboardFeature[] = [
  {
    icon: GlassWater,
    title: "Shift Schedule",
    description: "View your upcoming shifts",
    href: "/dashboard/staff/schedule",
  },
  {
    icon: ClipboardList,
    title: "Bar Reports",
    description: "Submit end of shift reports",
    href: "/dashboard/staff/reports",
  },
  {
    icon: BadgeCheck,
    title: "Certifications",
    description: "Manage your certifications",
    href: "/dashboard/staff/certifications",
  }
];
